export default {"src":"/_next/static/media/bike-score.dd50bd6a.svg","height":77,"width":76,"blurWidth":0,"blurHeight":0};